module.exports = __webpack_public_path__ + "static/media/vigold.6d3c074d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/climasense/roya_maiz/curativa/vigold.png
// module id = 1720
// module chunks = 3